<template>
    <div>
      <v-container>
        <HandleCreateNewFYAdditionalDataGrp
        :dialog="showAdditionalDataGrpDialog"
        :response="aditionalDataResultObj"
        :programName="programName"
        @openCloseDialog="openCloseDialog"
        />
        <v-dialog
        v-model="isDialog"
        persistent
        max-width="60vw">
        <v-overlay :value="overlay">
          <v-progress-circular
            indeterminate
            size="64"
          ></v-progress-circular>
        </v-overlay>
        <v-card>
          <v-card-title>
            <span></span>
          </v-card-title>
          <v-card-text>
            <v-form ref="form">
              <v-container>
                <v-row align="center">
                  <v-col cols="3">
                    <v-text-field
                    v-model.number="nextFiscalYear"
                    label="Fiscal Year"
                    type="number"
                    @keydown="onFyChange"
                    @change="onFyChange"
                    @blur="onFyChange"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                    v-model="businessDate"
                    :label="`Business Date`"
                    readonly
                    />
                  </v-col>
                  <v-col cols="3">
                    <MultiItemSelect
                    v-model="selectedBanks"
                    label="Bank"
                    :items="banks"
                    :item-list="bankList"
                    item-text="bankName"
                    item-value="_id"
                    single-line
                    @selected-items="selectedBanks"
                    multiple
                    >
                    </MultiItemSelect>
                  </v-col>
                  <v-col cols="3">
                    <MultiItemSelect
                    v-model="selectedFunds"
                    label="Fund"
                    :items="funds"
                    :item-list="fundList"
                    item-text="fundDesc"
                    item-value="_id"
                    single-line
                    @selected-items="selectedFunds"
                    multiple
                    >
                    </MultiItemSelect>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4">
                    <v-text-field
                    v-model="section"
                    label="Section"
                    type="text"
                    readonly
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
              <v-btn
                color="blue darken-1"
                text
                @click="performAction"
                :disabled="isGLCreate"
              >
                Create
              </v-btn>
              <v-btn
              color="blue darken-1"
              text
              @click="close"
            >
              Cancel
            </v-btn>
          </v-card-text>
        </v-card>
        </v-dialog>
      </v-container>
    </div>
  </template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import HandleCreateNewFYAdditionalDataGrp from '../../common/createNewFiscalYear/HandleCreateNewFYAdditionalDataGrp.vue';
import { calculateFiscalYears } from '../../../util/shared/tmc-global';
import { isEmptyObject } from '../../../util/shared/vue-global';
import MultiItemSelect from '../../common/base/MultiItemSelect.vue';

const fundCrudKey = 'sharedFund';
export default {
  name: 'GlCreateFiscalYear',
  components: {
    MultiItemSelect,
    HandleCreateNewFYAdditionalDataGrp,
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    overlay: false,
    glBaseCrudKey: 'glDailyTransaction',
    programName: '',
    businessDate: '',
    isGLCreate: true,
    section: '',
    funds: [],
    banks: [],
    banksList: [],
    isSelectedFund: false,
    isSelectedBank: false,
    selectedFundList: [],
    selectedBankList: [],
    nextFiscalYear: undefined,
    currentFiscalYear: undefined,
    showAdditionalDataGrpDialog: false,
    aditionalDataResultObj: {},
  }),
  created() {
    this.initializeDialogBox();
    this.loadList();
  },
  computed: {
    ...mapGetters('base/crud', ['criteria', 'item', 'items']),
    ...mapState({
      regYears: (state) => state.glDaily.glDailyTransaction.regYears,
    }),
    isDialog: {
      get() {
        return this.dialog;
      },
      set(value) {
        this.$emit('dialogVal', value);
      },
    },
    fundList() {
      const fundObjs = this.items(fundCrudKey) || [];
      const updatedFundObj = fundObjs.map((f) => ({
        ...f,
        fundDesc: f.fund === '0000' ? f.description : `${f.fund} - ${f.description || ''}`,
      }));
      return [...updatedFundObj];
    },
    bankList() {
      const bankObjs = this.banksList;
      return bankObjs;
    },
    fiscalYearList() {
      const registerdYears = (this.regYears || {});
      const allowAll = false;
      return calculateFiscalYears(registerdYears, allowAll);
    },
  },
  methods: {
    ...mapActions('glDaily/glDailyTransaction', ['loadFiscalRegYears']),
    ...mapActions('createNewFiscalYearManager', ['createNewFiscalYear']),
    ...mapActions('shared/bank', [
      'loadBanks',
    ]),
    ...mapActions('shared/fund', [
      'loadFunds',
    ]),
    onFyChange() {
      this.currentFiscalYear = this.nextFiscalYear - 1;
      this.businessDate = `${this.currentFiscalYear}-06-30`;
      this.loadFundsList();
    },
    initializeDialogBox() {
      this.loadFiscalRegYears({ baseCrudKey: this.glBaseCrudKey }).then(() => {
        const regYears = this.fiscalYearList || [];
        if ((regYears || []).length > 0) {
          this.currentFiscalYear = (regYears[regYears.length - 1] || {}).year;
          this.nextFiscalYear = this.currentFiscalYear + 1;
          this.businessDate = `${this.currentFiscalYear}-06-30`;
          this.section = 'Journal Entry';
          /* Call fund list after getting FY */
          this.loadFundsList();
        }
      }).catch((e) => {
        console.warn(e);
      });
    },
    async handleCreateNewFiscalYearResult(resultObj) {
      if (!isEmptyObject(resultObj)) {
        if ((resultObj.componentStatusArr || []).length > 0) {
          this.showAdditionalDataGrpDialog = true;
          this.aditionalDataResultObj = resultObj;
          this.programName = resultObj.programName;
        }
      }
    },
    selectedFunds(val) {
      this.isSelectedFund = true;
      this.funds = val;
    },
    selectedBanks(val) {
      this.isSelectedBank = true;
      this.banks = val;
    },
    async loadBankList() {
      const bankList = await this.loadBanks({
        criteria: {},
        baseCrudKey: 'sharedBank',
      });
      this.banks = bankList;
      if (bankList.length > 1) {
        this.isGLCreate = false;
      } else {
        this.isGLCreate = true;
      }
      return bankList;
    },
    async loadFundsList() {
      const fundList = await this.loadFunds({
        criteria: {
          fiscalYear: this.currentFiscalYear,
          sortBy: [
            {
              column: 'fund',
              direction: 'asc',
            },
          ],
        },
        baseCrudKey: 'sharedFund',
      });
      this.funds = this.fundList;
      if (fundList.length > 1) {
        this.isGLCreate = false;
      } else {
        this.isGLCreate = true;
      }
      return fundList;
    },
    async loadList() {
      this.banksList = await this.loadBankList();
    },
    async glCreateNewFiscalYear() {
      this.selectedFundList = this.isSelectedFund ? (this.fundList || [])
        .filter((f) => (this.funds || []).includes(f._id)) : (this.funds || []);
      this.selectedBankList = this.isSelectedBank ? (this.bankList || [])
        .filter((f) => (this.banks || []).includes(f._id)) : (this.banks || []);
      const result = await this.createNewFiscalYear({
        programName: this.glBaseCrudKey,
        nextFiscalYear: this.nextFiscalYear,
        currentFiscalYear: this.currentFiscalYear,
        params: {
          businessDate: this.businessDate,
          section: 'J',
          fundsList: this.selectedFundList,
          banksList: this.selectedBankList,
        },
      });
      this.isSelectedFund = false;
      this.isSelectedBank = false;
      await this.loadFiscalRegYears({ baseCrudKey: this.glBaseCrudKey });
      return result;
    },
    async performAction() {
      this.overlay = true;
      this.onFyChange();
      const resultObj = await this.glCreateNewFiscalYear();
      this.handleCreateNewFiscalYearResult(resultObj);
      this.overlay = false;
      this.close();
    },
    close() {
      this.isDialog = false;
    },
    openCloseDialog(value) {
      this.showAdditionalDataGrpDialog = value;
    },
  },
};
</script>
